import { Component, FocusEvent, FormEvent } from 'react'
import { breaksHundreds, isNotPositiveIntegerValue, removeSpaces } from '@shared/utils/helpers'

import { InputRangeOldProps } from './model'
import { View } from './view'
interface InputRangeOldState {
	inputValue: string
}

export class InputRangeOld extends Component<InputRangeOldProps, InputRangeOldState> {
	state: InputRangeOldState = {
		inputValue: breaksHundreds(this.props.value),
	}

	handleChange = (value: number | string) => {
		const { min, max, onChange } = this.props
		if (isNotPositiveIntegerValue(value)) {
			return
		}

		if (+value < min!) {
			onChange(min!)
			this.setState({ inputValue: breaksHundreds(min!) })
			return
		}

		if (+value > max!) {
			onChange(max!)
			this.setState({ inputValue: breaksHundreds(max!) })
			return
		}

		onChange(+value)
		this.setState({ inputValue: breaksHundreds(value) })
	}

	handleInputBlur = (e: FocusEvent<HTMLInputElement>) => {
		const { min, max, onChange } = this.props
		const cleanStrValue = removeSpaces(e.currentTarget.value)
		if (isNotPositiveIntegerValue(cleanStrValue)) {
			onChange(min!)
			this.setState({ inputValue: breaksHundreds(min!) })
			return
		}

		const numberValue = +cleanStrValue

		if (numberValue < min!) {
			onChange(min!)
			this.setState({ inputValue: breaksHundreds(min!) })
			return
		}

		if (numberValue > max!) {
			onChange(max!)
			this.setState({ inputValue: breaksHundreds(max!) })
			return
		}

		onChange(numberValue)
		this.setState({ inputValue: breaksHundreds(numberValue) })
	}

	handleInputChange = (e: FormEvent<HTMLInputElement>) => {
		const { min, max, onChange } = this.props
		const cleanStrValue = removeSpaces(e.currentTarget.value)
		this.setState({ inputValue: cleanStrValue })

		if (isNotPositiveIntegerValue(cleanStrValue)) {
			onChange(min!)
			return
		}

		const numberValue = +cleanStrValue

		if (numberValue < min!) {
			onChange(min!)
			return
		}

		if (numberValue > max!) {
			onChange(max!)
			return
		}

		onChange(numberValue)
	}

	componentDidUpdate(prevProps: InputRangeOldProps) {
		if (prevProps.min !== this.props.min && this.props.value < this.props.min!) {
			this.handleChange(this.props.min!)
		} else if (prevProps.max !== this.props.max && this.props.value > this.props.max!) {
			this.handleChange(this.props.max!)
		}
	}

	render() {
		const { inputValue } = this.state
		return View({
			...this.props,
			inputValue,
			handleChange: this.handleChange,
			handleInputBlur: this.handleInputBlur,
			handleInputChange: this.handleInputChange,
		})
	}
}
